import { Component, effect, inject, signal, computed, untracked } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule, ConnectedPosition } from '@angular/cdk/overlay';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { NotificationsService } from '../notifications.service';
import { NotificationPanelComponent } from '../notification-panel/notification-panel.component';

/**
 * Campanita del toolbar: burbujita con el nº de no vistas y panel anclado
 * debajo con cdkConnectedOverlay (cierra con click fuera y con Escape).
 */
@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatTooltipModule,
    OverlayModule,
    TranslatePipe,
    NotificationPanelComponent
  ],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.css']
})
export class NotificationBellComponent {
  protected readonly svc = inject(NotificationsService);

  protected readonly panelOpen = signal(false);
  protected readonly ringing = signal(false);

  protected readonly badgeText = computed(() => {
    const count = this.svc.unseenCount();
    return count > 99 ? '99+' : String(count);
  });

  /** Panel anclado bajo la campanita, alineado a la derecha; si no cabe, se abre hacia arriba. */
  protected readonly overlayPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 }
  ];

  private ringTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    // Animación sutil al llegar algo nuevo (pulse se incrementa en cada poll con eventos)
    effect(() => {
      if (this.svc.pulse() > 0) {
        untracked(() => this.ring());
      }
    });
  }

  protected toggle(): void {
    this.panelOpen.update(open => !open);
  }

  protected close(): void {
    this.panelOpen.set(false);
  }

  private ring(): void {
    if (this.ringTimeout) {
      clearTimeout(this.ringTimeout);
    }
    // Quitar y volver a poner la clase en tareas separadas reinicia la animación CSS
    this.ringing.set(false);
    setTimeout(() => this.ringing.set(true), 20);
    this.ringTimeout = setTimeout(() => this.ringing.set(false), 1300);
  }
}
